module.exports = __webpack_public_path__ + "static/img/coin_icon.0176f58e.png";